import * as React from "react";
import { Text, TextProps } from "react-native";
import { cn } from "./common/shadcn/utils";
import StyledText from "./common/ui/styled-text";

type BadgeVariant = "default" | "secondary" | "destructive" | "outline";

const badgeStyles = {
  base: "inline-flex items-center rounded-lg border px-2 py-0.5 text-xs font-semibold cursor-default select-text",
  variants: {
    default: "border-transparent bg-primary text-primary-foreground shadow",
    secondary: "border-transparent bg-secondary text-secondary-foreground",
    destructive:
      "border-transparent bg-destructive text-destructive-foreground shadow",
    outline: "text-foreground border-border",
  },
};

export interface BadgeProps extends Omit<TextProps, "children"> {
  variant?: BadgeVariant;
  children?: React.ReactNode;
  className?: string;
}

function Badge({
  className,
  variant = "default",
  children,
  ...props
}: BadgeProps) {
  return (
    <Text
      className={cn(badgeStyles.base, badgeStyles.variants[variant], className)}
      {...props}
    >
      {children}
    </Text>
  );
}

export { Badge };
